import moment from "moment";
import { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import DatePicker from "react-datepicker";
import { useTranslation } from "react-i18next";
import Select from "react-select";
import { Badge, CardHeader, Form, Input, Label, Spinner } from "reactstrap";
import {
  getChapterBySUbjectLMSDD,
  getClassDD,
  getSessionAPI,
  getSessionDD,
  getStreamByClassDD,
  getSubjectByClassDD,
  getSubjectByClassLMSDD,
} from "../../api/LMS/master";
import { Button, Col, Icon, PreviewAltCard, Row } from "../../components/Component";
import MyLoader from "../Loader/MyLoader";
import Required from "../validate/Required";
import useLogout from "../../hooks/useLogout";
import { toast } from "react-toastify";
import { decrypt } from "../../utils/Encrypt";

const ApiPaginationDataTable = ({
  data,
  columns,
  title,
  isLoading,
  className,
  handleTabClick,
  showSecondTable,
  activeTab,
  handleBackClick,
  watch,
  showThirdTable,
  handleThirdTableBackClick,
  search,
  selectableRows,
  zoneList,
  tabs,
  handleImageOpenPreview,
  owner,
  exp,
  keysToExport,
  setValue,
  register,
  errors,
  trigger,
  handleSubmit,
  handleSearch,
  searchPlaceholder, //search placeholder
  date, //to enable date filter
  type, //to enable type filter
  zone, //to enable zone filter
  camp, //to enable camp filter
  campReq, //to enable required on camp
  handlePerRowsChange,
  handlePageChange,
  totalRows,
  perPage,
  dashTab, //to enable tabs in dashboard card click
  serverSearch, // to enable server side search
  serverSideSearch, //function to initiate search
  campUser,
  pos,
  session, //to get session
  Class, // to get class
  subject, // get subject
  subjectReq, //enable required in subject
  chapter,
  chapterReq,
  stream,
}) => {
  const { t } = useTranslation();
  const IMAGE_BASE_URL = localStorage.getItem("IMAGE_BASE_URL");
  const enc = JSON.parse(localStorage.getItem("userDetail"));
  const user = decrypt(enc?.data || []);
  // Customizing pagination text and no data component
  const paginationComponentOptions = {
    rowsPerPageText: "Rows per page",
    rangeSeparatorText: "of",
    noRowsPerPage: false,
    selectAllRowsItem: true,
    selectAllRowsItemText: "All",
  };
  const customStyles = {
    headRow: {
      style: {
        border: "none",
      },
    },
    headCells: {
      style: {
        color: "#202124",
        fontSize: "14px",
      },
    },
    rows: {
      highlightOnHoverStyle: {
        backgroundColor: "rgb(230, 244, 244)",
        borderBottomColor: "#FFFFFF",
        borderRadius: "1px",
        outline: "1px solid #FFFFFF",
      },
    },
    pagination: {
      style: {
        border: "none",
      },
    },
  };

  const [filterText, setFilterText] = useState("");
  const [filteredItems, setFilteredItems] = useState(data);
  const logout = useLogout();
  useEffect(() => {
    let filteredData = data;
    switch (title) {
      case "Employee List":
        filteredData = data.filter((item) => {
          const filter = filterText.toLowerCase();
          const fullname = `${item.first_name} ${item.last_name}`;
          return (
            (fullname && fullname.toLowerCase().includes(filter)) ||
            (item.phone && item.phone.toLowerCase().includes(filter)) ||
            (item.pincode && item.pincode.toLowerCase().includes(filter)) ||
            (item.role && item.role.toLowerCase().includes(filter))
          );
        });
        break;
      case "Ward List":
        filteredData = data.filter((item) => {
          const filter = filterText.toLowerCase();
          return (
            (item.label && item.label.toLowerCase().includes(filter)) ||
            (item.zone_name && item.zone_name.toLowerCase().includes(filter)) ||
            (item.ward_code && item.ward_code.toLowerCase().includes(filter))
          );
        });
        break;
      default:
        break;
    }
    setFilteredItems(filteredData);
  }, [filterText, data, title]);

  useEffect(() => {
    if (user?.role == "Subject Specialist") {
      const body = {
        subject_id: user?.subject_id,
      };
      getChapterBySUbjectLMSDD(body)
        .then((res) => {
          const status = res.data.status;
          if (status) {
            setValue("chapterList", res.data.data);
          } else if (!status) {
            setValue("chapterList", []);
          } else if (status === "expired") {
            toast.error(res.data.message);
            toast.clearWaitingQueue();
            logout();
          }
        })
        .catch((err) => {
          console.log("Err", err);
        });
    } else { 
      getClassList();

    }
    getSessionList();
  }, []);
  const getSessionList = () => {
    getSessionDD()
      .then((res) => {
        const status = res.data.status;
        if (status) {
          setValue("sessionList", res.data.data);
        } else {
          setValue("sessionList", []);
        }
      })
      .catch((err) => {
        console.log("something went wrong");
      });
  };
  const getClassList = () => {
    getClassDD()
      .then((res) => {
        const status = res.data.status;
        if (status) {
          setValue("classList", res.data.data);
        } else {
          setValue("classList", []);
        }
      })
      .catch((err) => {
        console.log("something went wrong");
      });
  };

  // const result = filteredItems?.map((item) =>
  //   Object?.fromEntries(Object?.entries(item)?.filter(([key]) => keysToExport?.includes(key)))
  // );

  const handleSessionChange = (selectedOption) => {
    setValue("session", selectedOption);
    trigger("session");
  };
  const handleSubjectChange = (e) => {
    setValue("subject", e);
    trigger("subject");
    const body = {
      subject_id: e?.value,
    };
    getChapterBySUbjectLMSDD(body)
      .then((res) => {
        const status = res.data.status;
        if (status) {
          setValue("chapterList", res.data.data);
        } else if (!status) {
          setValue("chapterList", []);
        } else if (status === "expired") {
          toast.error(res.data.message);
          toast.clearWaitingQueue();
          logout();
        }
      })
      .catch((err) => {
        console.log("Err", err);
      });
  };
  const handleChapterChange = (opt) => {
    setValue("chapter", opt);
  };
  const handleClassChange = (selectedOption) => {
    setValue("class", selectedOption);
    trigger("class");
    setValue("subject", "");
    setValue("chapter", "");
    setValue("chapterList", []);
    setValue("subject", "");
    setValue("subjectList", []);
    setValue("stream", "");
    setValue("streamList", []);
    const body = {
      class_id: selectedOption?.value,
    };
    if (selectedOption?.value == "2" || selectedOption?.value == "3") {
      const data = {
        class_id: selectedOption?.value,
      };
      getStreamByClass(data);
    }
    if (selectedOption?.value == "1" || selectedOption?.value == "4") {
      getSubjectByClass(body);
    }
    return;
    getSubjectByClassLMSDD(body)
      .then((res) => {
        const status = res.data.status;
        if (status) {
          setValue("subjectList", res.data.data);
        } else if (!status) {
          setValue("subjectList", []);
        } else if (status === "expired") {
          toast.error(res.data.message);
          toast.clearWaitingQueue();
          logout();
        }
      })
      .catch((err) => {
        console.log("Err", err);
      });
  };
  const getStreamByClass = (data) => {
    getStreamByClassDD(data)
      .then((res) => {
        // decrypt data
        const status = res.data.status;
        // const status = decrypt(res.data.status);
        if (status) {
          // const decryptedResponse = decrypt(res.data.data.tableData);
          toast.success(res.data.message);
          setValue("streamList", res.data.data);
          toast.clearWaitingQueue();
        } else if (!status) {
          toast.warning(res.data.message);
          toast.clearWaitingQueue();
          setValue("streamList", []);
        } else if (status === "expired") {
          toast.error(res.data.message);
          logout();
        }
      })
      .catch((err) => {
        console.error(err);
      });
  };
  const getSubjectByClass = (body) => {
    getSubjectByClassLMSDD(body)
      .then((res) => {
        const status = res.data.status;
        if (status) {
          setValue("subjectList", res.data.data);
        } else if (!status) {
          setValue("subjectList", []);
        } else if (status === "expired") {
          toast.error(res.data.message);
          toast.clearWaitingQueue();
          logout();
        }
      })
      .catch((err) => {
        console.log("Err", err);
      });
  };
  const handleStreamChange = (selectedOption) => {
    setValue("stream", selectedOption || "");
    trigger("stream");
    // setValue("subject", null);
    const body = {
      class_id: watch("class")?.value,
      stream_id: selectedOption?.value,
    };
    getSubjectByClass(body);
  };
  const rowsPerPageOptions = [25, 50, 100, 500];
  return (
    <>
      <Row>
        <Col sm="12">
          <PreviewAltCard className={`my-2`}>
            <CardHeader>
              <div className="d-flex justify-content-between align-items-center">
                <h5>{title}</h5>

                {showThirdTable && (
                  <ul className="card-tools-nav mb-2" style={{ justifyContent: "end" }}>
                    <li className="d-flex align-items-center">
                      <Button color={`primary`} size={`xs`} onClick={() => handleThirdTableBackClick()}>
                        <Icon name={"arrow-long-left"} className={`me-1`} />
                        {"Back"}
                      </Button>
                    </li>
                  </ul>
                )}
              </div>
            </CardHeader>

            <div className="nk-data data-list">
              {search && (
                <div>
                  <Form onSubmit={handleSubmit(handleSearch)}>
                    <Row className={`g-gs`}>
                      {/* Zone */}
                      {session && (
                        <Col md="4" sm="4" xxl="2">
                          <div className="form-group">
                            <Label className="form-label" htmlFor="session">
                              {"Session"}
                              <Required />
                            </Label>

                            <Select
                              id="session"
                              placeholder={"Please select session"}
                              options={watch("sessionList")}
                              {...register("session", { required: { value: true, message: "Please select session" } })}
                              onChange={handleSessionChange}
                              value={watch("session")}
                            />
                            {errors.session && <span className="invalid">{errors.session.message}</span>}
                          </div>
                        </Col>
                      )}
                      {Class && user?.role == "Subject Specialist" ? null : (
                        <Col md="4" sm="3" xxl="2">
                          <div className="form-group">
                            <Label className="form-label" htmlFor="class">
                              {"Class"}
                              <Required />
                            </Label>

                            <Select
                              id="class"
                              placeholder={"Please select class"}
                              options={watch("classList")}
                              {...register("class", { required: { value: false, message: "Please select class" } })}
                              onChange={handleClassChange}
                              value={watch("class")}
                            />
                            {errors.class && <span className="invalid">{errors.class.message}</span>}
                          </div>
                        </Col>
                      )}
                      {stream && user?.role == "Subject Specialist" ? null : (
                        <>
                          {" "}
                          {(watch("class")?.value == "2" || watch("class")?.value == "3") && (
                            <Col md={`2`}>
                              <div className="form-group">
                                <Label className="from-label" htmlFor="stream">
                                  Stream
                                  <Required />
                                </Label>
                                <div className="form-control-wrap">
                                  <Select
                                    className=""
                                    id="stream"
                                    options={watch("streamList")}
                                    {...register("stream", {
                                      required: "Please select stream",
                                    })}
                                    onChange={handleStreamChange}
                                    value={watch("stream")}
                                  />
                                  {errors?.stream && (
                                    <span
                                      className="invalid"
                                      style={{
                                        color: "#e85347",
                                        fontSize: "11px",
                                        fontStyle: "italic",
                                      }}
                                    >
                                      {errors?.stream?.message}
                                    </span>
                                  )}
                                </div>
                              </div>
                            </Col>
                          )}
                        </>
                      )}
                      {subject && user?.role == "Subject Specialist" ? null : (
                        <Col md="4" sm="3" xxl="2">
                          <div className="form-group">
                            <Label className="form-label" htmlFor="subject">
                              {"Subject"}
                              {subjectReq && <Required />}
                            </Label>
                            <Select
                              id="subject"
                              placeholder={"Please select subject"}
                              options={watch("subjectList")}
                              {...register("subject", { required: { value: false, message: "Please select subject" } })}
                              onChange={handleSubjectChange}
                              value={watch("subject")}
                            />
                            {errors.subject && <span className="invalid">{errors.subject.message}</span>}
                          </div>
                        </Col>
                      )}
                      {chapter && (
                        <Col md="4" sm="3" xxl="4">
                          <div className="form-group">
                            <Label className="form-label" htmlFor="chapter">
                              {"Chapter"}
                              {subjectReq && <Required />}
                            </Label>
                            <Select
                              id="chapter"
                              placeholder={"Please select chapter"}
                              options={watch("chapterList")}
                              {...register("chapter", { required: { value: false, message: "Please select chapter" } })}
                              onChange={handleChapterChange}
                              value={watch("chapter")}
                            />
                            {errors.chapter && <span className="invalid">{errors.chapter.message}</span>}
                          </div>
                        </Col>
                      )}

                      {/* From Date */}
                      {date && (
                        <Col md="4" sm="3" xxl="2">
                          <div className="form-group">
                            <Label htmlFor="from_date" className="form-label">
                              {"From Date"}
                              <Required />
                            </Label>
                            <div className="form-control-wrap">
                              <DatePicker
                                id="from_date"
                                className="form-control date-picker"
                                placeholderText={"Please choose date"}
                                {...register("from_date", {
                                  required: "from date is required",
                                })}
                                onChange={(date) => {
                                  const formattedDate = moment(date).format("DD-MMM-YYYY"); // Format the date here
                                  setValue("from_date", date); // Save the formatted date
                                  trigger("from_date");
                                }}
                                selected={watch("from_date")}
                                dateFormat="dd/MM/yyyy"
                                maxDate={new Date()}
                                minDate={moment().subtract(70, "years").toDate()}
                                showYearDropdown
                                scrollableYearDropdown
                                dropdownMode="select"
                                showMonthDropdown
                                // yearDropdownItemNumber={12}
                              />
                            </div>
                            {errors.from_date && <p className="invalid">{errors.from_date.message}</p>}
                          </div>
                        </Col>
                      )}
                      {/* To Date */}
                      {date && (
                        <Col md="4" sm="3" xxl="2">
                          <div className="form-group">
                            <Label htmlFor="to_date" className="form-label">
                              {"To Date"}
                              <Required />
                            </Label>
                            <div className="form-control-wrap">
                              <DatePicker
                                id="to_date"
                                className="form-control date-picker"
                                placeholderText={"Please choose date"}
                                {...register("to_date", {
                                  required: "to date is required",
                                })}
                                onChange={(date) => {
                                  const formattedDate = moment(date).format("DD-MMM-YYYY"); // Format the date here
                                  setValue("to_date", date); // Save the formatted date
                                  trigger("to_date");
                                }}
                                selected={watch("to_date") || new Date()}
                                dateFormat="dd/MM/yyyy"
                                maxDate={new Date()}
                                minDate={watch("from_date")}
                                showYearDropdown
                                scrollableYearDropdown
                                dropdownMode="select"
                                // withPortal

                                showMonthDropdown
                                // yearDropdownItemNumber={12}
                              />
                            </div>
                            {errors.to_date && <p className="invalid">{errors.to_date.message}</p>}
                          </div>
                        </Col>
                      )}
                    </Row>
                    <Button disabled={isLoading} className={`my-2`} color={`primary`}>
                      {isLoading ? <Spinner size="sm" color="light" /> : "Submit"}
                    </Button>
                  </Form>
                </div>
              )}

              <div className={`chat-box ${tabs ? "d-flex justify-content-between" : ""}`}>
                <div className="people-list ">
                  <div className="search d-flex justify-content-between">
                    {serverSearch ? (
                      <div className={`form-control-wrap`}>
                        <div className="form-icon form-icon-right xl">
                          <Icon
                            name="search"
                            style={{
                              position: "absolute",
                              top: "20%",
                              right: "10px",
                            }}
                          ></Icon>
                        </div>
                        <Input
                          className="form-control"
                          type="text"
                          placeholder={searchPlaceholder || "search"}
                          value={watch("server_search")}
                          onChange={(e) => setValue("server_search", e.target.value)}
                          style={{ width: "360px" }}
                        />
                        {watch("server_search")?.length > 0 && (
                          <Button
                            className={`my-1`}
                            size={`xs`}
                            outline
                            color="primary"
                            onClick={() => serverSideSearch(watch("server_search"), title)}
                          >
                            Search
                          </Button>
                        )}
                      </div>
                    ) : (
                      <Form className="theme-form">
                        <div className={`form-control-wrap`}>
                          <div className="form-icon form-icon-right xl">
                            <Icon
                              name="search"
                              style={{
                                position: "absolute",
                                top: "20%",
                                right: "10px",
                              }}
                            ></Icon>
                          </div>
                          <Input
                            className="form-control"
                            type="text"
                            placeholder={searchPlaceholder || "search"}
                            value={filterText}
                            onChange={(e) => setFilterText(e.target.value)}
                            style={{ width: "360px" }}
                          />
                          {/* <i className="fa fa-search"></i> */}
                        </div>
                      </Form>
                    )}
                    {/* {exp ? <Export sheetName={title} data={result} /> : null} */}
                  </div>
                </div>
              </div>
              <DataTable
                className={className}
                columns={columns}
                data={filteredItems}
                progressPending={isLoading}
                progressComponent={<MyLoader />}
                noDataComponent={"There are no records to display"}
                subHeader={false}
                persistTableHead
                onColumnOrderChange
                striped={true}
                responsive={true}
                highlightOnHover
                customStyles={customStyles}
                pagination
                paginationServer
                paginationTotalRows={totalRows}
                paginationPerPage={perPage}
                onChangeRowsPerPage={handlePerRowsChange}
                onChangePage={handlePageChange}
                // paginationRowsPerPageOptions={[50, 100, 500,totalRows]} // Only numbers
                paginationRowsPerPageOptions={rowsPerPageOptions}
                paginationComponentOptions={{
                  rowsPerPageText: "Rows per page",
                  selectAllRowsItem: true, // enables the "All" option
                  selectAllRowsItemText: "All", // label shown for the "All" option
                }}
              />
            </div>
          </PreviewAltCard>
        </Col>
      </Row>
    </>
  );
};

export default ApiPaginationDataTable;
